// extracted by mini-css-extract-plugin
module.exports = {"container":"Goods-module--container--2X6YS","layout":"Goods-module--layout--1zmkh","wrapper":"Goods-module--wrapper--35X_p"};